import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginWrapperComponent } from './wrapper/login-wrapper/login-wrapper.component';
import { HomeWrapperComponent } from './wrapper/home-wrapper/home-wrapper.component';
import { FaqWrapperComponent } from './wrapper/faq-wrapper/faq-wrapper.component';
import { ModeResolver } from './wrapper/login-wrapper/mode.resolver';
import { CheckoutCompleteWrapperComponent } from './wrapper/checkout-complete-wrapper/checkout-complete-wrapper.component';
import { SearchWrapperComponent } from './wrapper/search-wrapper/search-wrapper.component';
import { AlbumsWrapperComponent } from './wrapper/albums-wrapper/albums-wrapper.component';
import { UploadWrapperComponent } from './wrapper/upload-wrapper/upload-wrapper.component';
import { CartWrapperComponent } from './wrapper/cart-wrapper/cart-wrapper.component';
import { PurchasesWrapperComponent } from './wrapper/purchases-wrapper/purchases-wrapper.component';
import { ProfileWrapperComponent } from './wrapper/profile-wrapper/profile-wrapper.component';
import { ResetWrapperComponent } from './wrapper/reset-wrapper/reset-wrapper.component';
import { DownloadsWrapperComponent } from './wrapper/downloads-wrapper/downloads-wrapper.component';
import { SavedSearchesWrapperComponent } from './wrapper/saved-searches-wrapper/saved-searches-wrapper.component';
import { AutologinWrapperComponent } from './wrapper/autologin-wrapper/autologin-wrapper.component';
import { AutologinwithcriteriaWrapperComponent } from './wrapper/autologinwithcriteria-wrapper/autologinwithcriteria-wrapper.component';
import { DxMainWrapperComponent } from './wrapper/dx-main-wrapper/dx-main-wrapper.component';
import { LogoutSplashWrapperComponent } from './wrapper/logout-splash-wrapper/logout-splash-wrapper.component';

import { MemorialPrintComponent } from './components/custom/memorial-print/memorial-print.component';

const routes: Routes = [
  /**
   * to support declaimer create use component: NavigationProxyComponent:
       @Component({
		  selector: 'app-navigation-proxy',
		  templateUrl: './navigation-proxy.component.html'
		})
     
        export class NavigationProxyComponent {
		  showNav = true;
		
		  constructor(configService: ConfigService) {
		    const config = configService.getConfig();
		    if (config?.auth?.disclaimer) {
		      const disclaimer = localStorage.getItem('kv_disclaimer');
		      this.showNav = disclaimer === 'accepted';
		    }
		  }
		}
		
		<ng-container *ngIf="showNav">
		  <app-navigation></app-navigation>
		</ng-container>

   */
	{
		path: '',
		component: HomeWrapperComponent,
		data: {
			stateId: 'home',
			pageTitle: 'Welcome to Knowvation'
		}
	},
	{
		path: 'faq',
		component: FaqWrapperComponent,
		data: {
			stateId: 'faq',
			pageTitle: 'Knowvation - FAQ'
		}
	},
	{
		path: 'login',
		component: LoginWrapperComponent,
		resolve: {
			mode: ModeResolver
		},
		data: {
			stateId: 'login',
			pageTitle: 'Knowvation Login'
		}		
	},
	{
		path: 'cart',
		component: CartWrapperComponent
	},
	{
		path: 'purchases',
		component: PurchasesWrapperComponent
	},
	{
		path: 'profile',
		component: ProfileWrapperComponent,
		data: {
			stateId: 'profile',
			pageTitle: 'Knowvation - Profile'
		}
	},
	{
		path: 'reset',
		component: ResetWrapperComponent
	},
	{
		path: 'downloads',
		component: DownloadsWrapperComponent,
		data: {
			stateId: 'downloads',
			pageTitle: 'Knowvation - Downloads'
		}
	},
	{
		path: 'saved-searches',
		component: SavedSearchesWrapperComponent,
		data: {
			stateId: 'saved-searches',
			pageTitle: 'Knowvation - Saved Searches'
		}
	},
	{
		path: 'checkout-complete',
		component: CheckoutCompleteWrapperComponent
	},
	{
		path: 's',
		component: SearchWrapperComponent,
		data: {
			stateId: 'search',
			pageTitle: 'Knowvation - Search'
		}
	},
	{
		path: 'albums',
		component: AlbumsWrapperComponent,
		data: {
			stateId: 'albums',
			pageTitle: 'Knowvation - Albums'
		}
	},
	{
		path: 'autologin/:token',
		component: AutologinWrapperComponent,
		data: {
			pageTitle: 'Knowvation'
		}
	},
	{
		path: 'autologin/:token/:criteria',
		component: AutologinwithcriteriaWrapperComponent,
		data: {
			pageTitle: 'Knowvation'
		}
	},
	{
		path: 'upload',
		component: UploadWrapperComponent,
		data: {
			stateId: 'upload',
			pageTitle: 'Knowvation - Upload'
		}
	},
	{
		path: 'dx',
		component: DxMainWrapperComponent,
		data: {
			stateId: 'dx-main',
			pageTitle: 'Knowvation - Workflow'
		}
	},
	{
		path: 'logout-splash',
		component: LogoutSplashWrapperComponent,
		data: {
			pageTitle: 'Knowvation'
		}
	},
	{ path: 'print/certificate/:id', component: MemorialPrintComponent }
];

@NgModule({
  imports: [
	  RouterModule.forRoot(routes, { useHash: false })
	  /*RouterModule.forRoot(routes, {
	      // Essential for hybrid apps
	      initialNavigation: 'enabledBlocking',
	      urlUpdateStrategy: 'deferred',
	      paramsInheritanceStrategy: 'emptyOnly',
	      
	      // Additional recommended settings
	      enableTracing: false,  // Set to true for debugging
	      scrollPositionRestoration: 'disabled',
	      anchorScrolling: 'disabled'
	    })*/
	  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
